import { render } from "./ReviewsMovie.vue?vue&type=template&id=fc2cdd92"
import script from "./ReviewsMovie.vue?vue&type=script&lang=js"
export * from "./ReviewsMovie.vue?vue&type=script&lang=js"
script.render = render

export default script